import constants from "lib/config";
import removeLocalStorage from "./removeLocalStorage";

export default function clearUsersLocalStorage() {
  removeLocalStorage(constants.authTokenName);
  removeLocalStorage(constants.refreshTokenName);
}
